import { useMutation, useQueryClient } from "react-query";
import request from "@common/request";
import { ProductPhase } from "@modules/tasks/types";

const useProductCreate = () =>
  useMutation(
    ({
      templateId,
      householdId,
    }: {
      templateId: string;
      householdId: string;
    }) =>
      request<Forme.Product>("POST", "/api/advisor/products", {
        data: { templateId, householdId },
      })
  );

const useCurrentProductUpdate = () => {
  const queryClient = useQueryClient();

  return useMutation(
    ({ productPhase }: { productPhase: ProductPhase }) =>
      request<Forme.Product>("PATCH", "/api/products/current", {
        data: { productPhase },
      }),
    {
      onMutate: async (params) => {
        await queryClient.cancelQueries({
          queryKey: ["currentProduct"],
        });
        const previousProduct = queryClient.getQueryData<Forme.Product>([
          "currentProduct",
        ]);

        if (previousProduct) previousProduct.currentPhase = params.productPhase;

        queryClient.setQueryData<Forme.Product[]>(
          ["currentProduct"],
          [previousProduct as Forme.Product]
        );

        return { previousProduct };
      },
      onError: (err, taskToRemove, context) => {
        const typedContext = context as { previousProduct: Forme.Product };
        queryClient.setQueryData(
          ["currentProduct"],
          typedContext.previousProduct
        );
      },
      onSettled: () => {
        queryClient.invalidateQueries({
          queryKey: ["currentProduct"],
        });
      },
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: ["household"],
        });
      },
    }
  );
};
export { useProductCreate, useCurrentProductUpdate };
